<template>
  <div id="base" class="success-container" v-title title="开户成功">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="header-content">
        <img id="u52_img" class="background-img" src="@/images/shenqin/u52.png" alt="背景"/> 
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 成功提示区域 -->
      <div class="success-card">
        <!-- 成功图标动画 -->
        <div class="success-animation">
          <div class="success-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </div>
          <div class="confetti"></div>
          <div class="confetti"></div>
          <div class="confetti"></div>
          <div class="confetti"></div>
          <div class="confetti"></div>
        </div>

        <!-- 成功标题 -->
        <div class="success-header">
          <h1>开户成功！</h1>
          <p class="success-subtitle">您的机构信息已成功提交，请耐心等待审核</p>
        </div>

        <!-- 账户信息卡片 -->
        <div class="account-card">
          <div class="card-header">
            <div class="card-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
              </svg>
            </div>
            <h3>开户信息</h3>
            <p class="card-subtitle">以下为本次提交的机构信息</p>
          </div>
          
          <div class="account-info">
            <div class="info-grid">
              <div class="info-item">
                <div class="info-label">
                  <svg viewBox="0 0 24 24" fill="currentColor" class="info-icon">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                  </svg>
                  机构名称
                </div>
                <div class="info-value">{{ orgName   }}</div>
              </div>
              
              <div class="info-item">
                <div class="info-label">
                  <svg viewBox="0 0 24 24" fill="currentColor" class="info-icon">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                  法人姓名
                </div>
                <div class="info-value">{{ orgHeader   }}</div>
              </div>
              
              <div class="info-item">
                <div class="info-label">
                  <svg viewBox="0 0 24 24" fill="currentColor" class="info-icon">
                    <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/>
                  </svg>
                  手机号码
                </div>
                <div class="info-value">{{ orgHeaderPhone  }}</div>
              </div>
              
              <div class="info-item">
                <div class="info-label">
                  <svg viewBox="0 0 24 24" fill="currentColor" class="info-icon">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                  </svg>
                  提交状态
                </div>
                <div class="info-value">
                  <span class="status-badge submitted">已提交</span>
                </div>
              </div>
               
            </div>
          </div>
        </div>
 

        <!-- 操作按钮 -->
        <div class="action-buttons">
          <el-button class="btn-secondary" @click="goIndex">
            <svg viewBox="0 0 24 24" fill="currentColor" class="btn-icon">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
            </svg>
            返回首页
          </el-button> 
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <div class="link-item">
            <strong>主办：</strong>河北省体育局
          </div>
          <div class="link-item">
            <strong>地址：</strong>河北省石家庄市中山东路372号
          </div>
          <div class="link-item">
            <strong>邮编：</strong>050011
          </div>
          <div class="link-item">
            <strong>邮箱：</strong>hebeitiyuju@163.com
          </div>
          <div class="link-item">
            <strong>运维电话：</strong>0311-85266259
          </div>
        </div>
        <div class="footer-copyright">
          <p>河北省体育局版权所有 © 2025</p>
          <p class="icp-info">
            冀ICP备：2022017224号 | 冀公网安备：13010202002305号
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

 

<script>

export default {
  name: 'BaoBei',
  data() {
    return {
        orgName: '',  // 机构名称
        orgHeader: '',  // 法人姓名
        orgHeaderPhone:''//法人手机号
    }
  },
  created() {
      let kaihu = JSON.parse(localStorage.getItem('kaihu'));
      if(kaihu){
          this.orgName = kaihu.orgName;
          this.orgHeader = kaihu.orgHeader;
          this.orgHeaderPhone = kaihu.orgHeaderPhone
      }

  },
  methods: {
      goIndex(){
          this.$router.push('/')
      },
  }
}
</script>
<style scoped>
.success-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
}

/* 顶部导航栏样式 */
.header {
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 10;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto; 
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-background {
  flex: 1;
  display: flex;
  justify-content: center;
}

.background-img {
  width: 100%; 
  height: auto;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  overflow: hidden; /* 确保图片内容不会超出圆角边界 */
}

.logo {
  height: 50px;
  width: auto;
}

/* 主内容区样式 */
.main-content {
  flex: 1;
  max-width: 1000px;
  margin: 0 auto; 
  width: 100%;
}

/* 成功卡片 */
.success-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
}

/* 成功动画 */
.success-animation {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.success-icon {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;
  animation: scaleIn 0.8s ease-out;
  box-shadow: 0 10px 30px rgba(16, 185, 129, 0.3);
}

.success-icon svg {
  width: 50px;
  height: 50px;
}

.confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  background: linear-gradient(45deg, #f59e0b, #ef4444, #3b82f6, #10b981);
  border-radius: 50%;
  animation: confettiFall 2s ease-out forwards;
}

.confetti:nth-child(2) {
  left: 30%;
  top: 0;
  animation-delay: 0.2s;
}

.confetti:nth-child(3) {
  left: 50%;
  top: 20px;
  animation-delay: 0.4s;
}

.confetti:nth-child(4) {
  left: 70%;
  top: 0;
  animation-delay: 0.6s;
}

.confetti:nth-child(5) {
  left: 40%;
  top: 40px;
  animation-delay: 0.8s;
}

.confetti:nth-child(6) {
  left: 60%;
  top: 30px;
  animation-delay: 1s;
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  70% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes confettiFall {
  0% {
    transform: translateY(-100px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(300px) rotate(360deg);
    opacity: 0;
  }
}

/* 成功标题 */
.success-header {
  text-align: center;
  margin-bottom: 40px;
}

.success-header h1 {
  font-size: 36px;
  font-weight: 700;
  color: #10b981;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.success-subtitle {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
}

/* 账户信息卡片 */
.account-card {
  background: #f8f9fa;
  border-radius: 16px;
  padding: 30px;
  margin-bottom: 40px;
  border: 1px solid #e9ecef;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.card-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #3b82f620 0%, #2563eb20 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: #3b82f6;
}

.card-icon svg {
  width: 24px;
  height: 24px;
}

.card-header h3 {
  font-size: 22px;
  color: #333;
  margin: 0 0 4px 0;
}

.card-subtitle {
  color: #666;
  margin: 0;
  font-size: 14px;
}

/* 信息网格 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  padding: 15px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.info-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #3b82f6;
}

.info-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.info-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  color: #3b82f6;
}

.info-value {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.status-badge {
  padding: 6px 15px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.status-badge.submitted {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.status-badge.pending {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

/* 审核流程 */
.process-section {
  margin-bottom: 40px;
}

.section-header {
  text-align: center;
  margin-bottom: 30px;
}

.section-header h3 {
  font-size: 22px;
  color: #333;
  margin-bottom: 8px;
}

.section-header p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.process-steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.process-steps::before {
  content: '';
  position: absolute;
  top: 30px;
  left: 50px;
  right: 50px;
  height: 3px;
  background: linear-gradient(90deg, #10b981 0%, #e9ecef 50%, #e9ecef 100%);
  z-index: 1;
}

.process-step {
  position: relative;
  z-index: 2;
  text-align: center;
  flex: 1;
  padding: 0 10px;
}

.step-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #e9ecef;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  margin: 0 auto 15px;
  transition: all 0.3s ease;
}

.process-step.active .step-circle {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.step-content h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 6px;
}

.step-content p {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
  line-height: 1.4;
}

.step-time {
  font-size: 12px;
  color: #999;
  font-style: italic;
}

/* 温馨提示卡片 */
.tips-card {
  background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%);
  border-radius: 16px;
  padding: 25px;
  margin-bottom: 40px;
  border: 1px solid #ffecb5;
}

.tips-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.tips-icon {
  width: 30px;
  height: 30px;
  color: #f59e0b;
  margin-right: 12px;
}

.tips-header h3 {
  font-size: 18px;
  color: #f59e0b;
  margin: 0;
}

.tips-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tips-content li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.tips-content li:before {
  content: '•';
  color: #f59e0b;
  font-weight: bold;
  margin-right: 10px;
  flex-shrink: 0;
}

.tips-content li:last-child {
  margin-bottom: 0;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
}

.btn-primary {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 10px;
  padding: 14px 30px;
  font-size: 16px;
  font-weight: 500;
  height: auto;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.btn-secondary {
  background: white;
  border: 2px solid #dcdfe6;
  border-radius: 10px;
  padding: 14px 30px;
  font-size: 16px;
  font-weight: 500;
  height: auto;
  color: #333;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  border-color: #10b981;
  color: #10b981;
  background: #f0fdf4;
}

.btn-icon {
  width: 18px;
  height: 18px;
  margin: 0 8px;
}

.btn-primary .btn-icon {
  margin-left: 8px;
  margin-right: 0;
}

.btn-secondary .btn-icon {
  margin-right: 8px;
  margin-left: 0;
}

/* 底部样式 */
.footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #fff;
  padding: 40px 0 20px;
  margin-top: 60px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.link-item {
  color: #aaa;
  line-height: 1.8;
}

.link-item strong {
  color: #ccc;
}

.footer-copyright {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.footer-copyright p {
  margin: 5px 0;
}

.icp-info {
  font-size: 13px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .main-content {
    padding: 20px;
  }
  
  .success-card {
    padding: 25px;
  }
  
  .success-header h1 {
    font-size: 28px;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .process-steps {
    flex-direction: column;
    gap: 30px;
  }
  
  .process-steps::before {
    display: none;
  }
  
  .process-step {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 15px;
  }
  
  .step-circle {
    margin: 0;
    flex-shrink: 0;
  }
  
  .step-content {
    flex: 1;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 15px;
  }
  
  .btn-primary,
  .btn-secondary {
    width: 100%;
  }
  
  .footer-links {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .success-header h1 {
    font-size: 24px;
  }
  
  .success-icon {
    width: 80px;
    height: 80px;
  }
  
  .success-icon svg {
    width: 40px;
    height: 40px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .card-icon {
    margin-right: 0;
    margin-bottom: 12px;
  }
}
</style>